import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from "@angular/forms";
import { TelenetIconComponent } from "../telenet-icons/telenet-icon.component";

@Component({
   // eslint-disable-next-line @angular-eslint/component-selector
   selector: "telenet-checkbox",
   templateUrl: "./telenet-checkbox.component.html",
   styleUrls: ["./telenet-checkbox.component.scss"],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => TelenetCheckboxComponent)
      }
   ],
   imports: [FormsModule, TelenetIconComponent]
})
export class TelenetCheckboxComponent implements ControlValueAccessor {
   @Input() public disabled = false;

   @Input() public ngModel: boolean | undefined;
   @Output() public ngModelChange = new EventEmitter<boolean | undefined>();

   public onModelChange(checked: any): void {
      this.ngModel = checked;
      this.ngModelChange.emit(checked);
   }

   // Copy pasta delicious for no errors
   onChange: any = () => {};
   onTouch: any = () => {};
   registerOnChange(fn: any): void {
      this.onChange = fn;
   }
   registerOnTouched(fn: any): void {
      this.onTouch = fn;
   }

   checked: boolean = false;
   writeValue(checked: boolean) {
      this.checked = checked;
   }
}
